import axios from "axios";
import _ from "lodash";

import APIKeyList from "@/components/Common/APIKeyList/APIKeyList.vue";

import { confirmWarningConfig } from "@/configuration/confirmConfigurations";

const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import { getTokenHeader } from "@/helpers/commonHelper";

const defaultConfig = {};
export default {
  name: "MapsAdmin",
  components: { APIKeyList },
  data: () => ({
    snackbar: false,
    snackbarText: "",
    snackbarColor: "",
    dialog: false,
    editedKey: _.cloneDeep(defaultConfig),
    editedIndex: null,
    newConfig: false,
    apiKeyValid: false,
    changedDescription: []
  }),
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      await this.$store.dispatch("getMapsConfig");
      await this.$store.dispatch("getMapsApiKeys");
    },
    addChangedDescription(index) {
      if (!this.changedDescription.includes(index))
        this.changedDescription.push(index);
    },
    async addApiKey() {
      try {
        const newApiKey = {
          apiKey: String.random(),
          config_ref: this.config._id,
          description: ""
        };

        const headers = getTokenHeader();
        await axios.post(`${env.maps_api_client_url}apiKey/`, newApiKey, {
          headers
        });
        await this.$store.dispatch("createSuccess", "Erfolgreich gespeichert!");
        await this.$store.dispatch("getMapsApiKeys");
      } catch (e) {
        this.createError();
      }
    },
    async removeApiKey(key) {
      try {
        const isConfirmed = await this.$confirm(
          "Wollen Sie diesen API Key wirklich löschen?",
          confirmWarningConfig
        );
        if (isConfirmed) {
          const headers = getTokenHeader();
          await axios.delete(`${env.maps_api_client_url}apiKey/${key._id}`, {
            headers
          });
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich gespeichert!"
          );
          await this.$store.dispatch("getMapsApiKeys");
        }
      } catch (error) {
        await this.$store.dispatch("createError", error);
      }
    },
    createError(error) {
      this.snackbar = true;
      this.snackbarText =
        "Es ist ein Fehler aufgetreten. Bitte laden Sie die Seite neu oder versuchen Sie es später noch einmal";
      this.snackbarColor = "#c55c52";
      console.error(error);
    },

    async copyApiKey(apiKey) {
      let clone = {
        ...apiKey,
        apiKey: String.random(),
        description: apiKey.description + " (Kopie)"
      };

      delete clone._id;
      delete clone.updatedBy;
      delete clone.createdBy;
      try {
        const headers = getTokenHeader();
        const response = await axios.post(
          `${env.maps_api_client_url}apiKey/`,
          clone,
          {
            headers
          }
        );
        if (response.status === 201) {
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich gespeichert!"
          );
          await this.$store.dispatch("getMapsApiKeys");
        } else {
          this.createError();
        }
      } catch (e) {
        this.createError();
      }
    },

    editApiKey(index) {
      this.editedIndex = index;
      this.editedKey = Object.assign(
        {},
        { ...defaultConfig },
        { ...this.apiKeys[index] }
      );
      this.dialog = true;
    },
    closeKey() {
      this.editedIndex = null;
      this.editedKey = Object.assign({}, { ...defaultConfig });
      this.$refs.editView?.$refs?.fileInput?.reset();
      this.$refs.editView?.$refs?.logOverview?.resetLogs();
      this.dialog = false;
    },
    async saveKey(shouldCloseDialog) {
      if (this.isReadOnlyApiKey) {
        return;
      }
      if (this.apiKeyValid) {
        try {
          const headers = getTokenHeader();
          const response = await axios.put(
            `${env.maps_api_client_url}apiKey/${this.editedKey._id}`,
            this.editedKey,
            {
              headers
            }
          );
          if (response.status === 200) {
            await this.$store.dispatch(
              "createSuccess",
              "Erfolgreich gespeichert!"
            );
          }
          await this.$store.dispatch("getMapsApiKeys");

          const logOverviewRef = this.$refs.editView?.$refs?.logOverview;
          const logsFetched = logOverviewRef?.logsFetched;
          logOverviewRef?.resetLogs();

          if (shouldCloseDialog) {
            this.closeKey();
          } else if (logsFetched) {
            logOverviewRef?.getLogs().then(null);
          }
        } catch (ex) {
          this.createError(ex);
        }
      } else this.createError("Bitte füllen sie alle Pflichtfelder aus");
    },
    async updateApiKeyDescription(index) {
      try {
        const headers = getTokenHeader();
        const response = await axios.put(
          `${env.maps_api_client_url}apiKey/${this.apiKeys[index]._id}`,
          this.apiKeys[index],
          { headers }
        );
        if (response.status === 200) {
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich gespeichert!"
          );
        }
      } catch (e) {
        this.createError();
      }
    },
    async save() {
      const headers = getTokenHeader();
      let method = "put";
      if (this.newConfig) method = "post";
      try {
        if (this.changedDescription.length) {
          await this.changedDescription.asyncForEach(
            async changedDescription => {
              await this.updateApiKeyDescription(changedDescription);
            }
          );
          await this.$store.dispatch("getMapsApiKeys");
        }
        await axios[
          method
        ](
          `${env.maps_api_client_url}config/${this.selectedPrincipal?.id}/`,
          this.config,
          { headers }
        );
        await this.$store.dispatch("createSuccess", "Erfolgreich gespeichert");
        await this.$store.dispatch("getMapsConfig");
      } catch (ex) {
        this.createError();
      }
    }
  },
  computed: {
    config() {
      const config = this.$store.state.mapsConfig;
      if (!config || !Object.keys(config).length) this.newConfig = true;
      return config;
    },
    currentUser() {
      return this.$store.state.currentUser;
    },
    isAdmin() {
      return this.currentUser?.scopes?.includes("role:admin");
    },
    isMapsAdmin() {
      return this.currentUser?.scopes?.includes("role:maps_admin");
    },
    apiKeys() {
      return this.$store.state.mapsApiKeys;
    },
    isReadOnlyApiKey() {
      if (this.isAdmin) {
        return false;
      }
      if (this.editedKey.userPermission === "edit") {
        return false;
      }
      return true;
    },
    principal() {
      return this.$store.state.selectedPrincipal;
    },
    selectedPrincipal() {
      return this.$store.state.selectedPrincipal;
    }
  }
};
